/* eslint-disable @typescript-eslint/naming-convention */
import { Get } from 'config/apiServiceConfig'
import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

type FilterOptionsType = { data: { key: string; value: string }[] }

const ANALYTICS_BASE = '/analytics-data/internal/v1'

export const getBrandList = (keyword: string) =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/brands`,
    params: {
      keyword,
      page_size: 10,
    },
  })

export const getHubList = (name: string) =>
  Get({
    url: '/api/location',
    params: { type: 'HUB', name },
  })

export const getProductTypeList = () =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/product-types`,
  })

export const getCategoryL1List = (keyword: string) =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/l1-categories`,
    params: {
      keyword,
      page_size: 10,
    },
  })

export const getCategoryL2List = (keyword: string) =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/l2-categories`,
    params: {
      keyword,
      page_size: 10,
    },
  })

export const getPICList = (keyword: string) =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/pic-emails`,
    params: {
      keyword,
      page_size: 10,
    },
  })

export const getBusinessLineList = () =>
  axiosInstanceApiGateway.Get({
    url: `${ANALYTICS_BASE}/scms/filter-options/business-lines`,
    params: {
      page_size: 10,
    },
  })

export const getHardcodeReasonList = () =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/hardcode-reasons`,
    params: {
      page_size: 10,
    },
  })

export const getSourceList = () =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/source-status`,
    params: {
      page_size: 10,
    },
  })

export const getParetoList = () =>
  axiosInstanceApiGateway.Get<{ data: { key: string; name: string }[] }, true>({
    url: `${ANALYTICS_BASE}/pareto-classifications`,
  })

export const getCampaignTypeList = (name: string) =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/campaign-types`,
    params: {
      keyword: name,
    },
  })

export const getVendorList = (keyword: string) =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/vendors`,
    params: {
      keyword,
      page_size: 10,
    },
  })

export const getPaydayPeriodList = (keyword: string) =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/payday-periods`,
    params: {
      keyword,
    },
  })

export const getCategoryDemandList = (keyword: string) =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/category-demands`,
    params: {
      keyword,
    },
  })

export const getCampaignStatusList = () =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/campaign-status`,
  })

export const getFCStatusList = () =>
  axiosInstanceApiGateway.Get<FilterOptionsType, true>({
    url: `${ANALYTICS_BASE}/scms/filter-options/final-fc-status`,
  })

export const getProductSuggestions = (keys: string, values: string, cursor: string) =>
  axiosInstanceApiGateway.Get<
    { data: { key: string; value: string }[]; pagination: { next_cursor: string } },
    true
  >({
    url: `${ANALYTICS_BASE}/scms/filter-options/products`,
    params: {
      keys,
      values,
      page_size: 10,
      cursor,
    },
  })
